import { IState } from "../..";
import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "../../../app/store";
import { BillingReviewSummaryState } from "../ShipmentReconciliationState";
import ShipmentReconciliationService from "../../../app/data/shipment-reconciliation/shipmentReconciliationService";
import { BillingReviewWorkItemRequest } from "../../../app/data/shipment-reconciliation/models";

const initialState: BillingReviewSummaryState = {
  loading: false,
  loadingFailed: false,
  loaded: false,
  summary: {
    totalShipmentWorkItems: 0,
    pendingBillingReview: 0,
    compltedBillingReview: 0
  }
};

const shipmentReconciliationService = ShipmentReconciliationService.getInstance();

export const getBillingReviewSummarySlice = createSlice({
  name: "getBillingReviewSummarySlice",
  initialState,
  reducers: {
    resetGetBillingReviewSummaryState: (state) => initialState,
    getBillingReviewSummaryLoadingStarted: (state) => {
      state.loading = true;
      state.loadingFailed = false;
      state.loaded = false;
    },
    getBillingReviewSummarySucceed: (state, { payload }) => {
      state.loaded = true;
      state.loading = false;
      state.loadingFailed = false;
      state.summary = payload;
    },
    getBillingReviewSummaryLoadingFailed: (state, { payload }) => {
      state.loading = false;
      state.loadingFailed = true;
    },
    changeBillingReviewSummaryLocally: (state, { payload }) => {
      if (payload.summary) state.summary = payload.summary;
    },
  },
});

export const {
  resetGetBillingReviewSummaryState,
  getBillingReviewSummaryLoadingStarted,
  getBillingReviewSummarySucceed,
  getBillingReviewSummaryLoadingFailed,
  changeBillingReviewSummaryLocally,
} = getBillingReviewSummarySlice.actions;

export const getBillingReviewSummarySelector = (state: IState) => state.billingReviewSummary;

export const getBillingReviewSummaryItems = (
  requestData: BillingReviewWorkItemRequest,
  onError?: (error: string) => void
): AppThunk => async (dispatch) => {
  dispatch(getBillingReviewSummaryLoadingStarted());
  const response = await shipmentReconciliationService.getBillingReviewSummary(requestData);
  if (response.ok() && response.data) {
    dispatch(getBillingReviewSummarySucceed(response.data));
  } else {
    let error = "Internal Server Error, re-try the action or contact support";
    if (response && response.data && response.data.message) error = JSON.stringify(response.data.message);
    dispatch(getBillingReviewSummaryLoadingFailed(error));
    onError && onError(error)
  }
};

const getBillingReviewSummaryReducer = getBillingReviewSummarySlice.reducer;
export default getBillingReviewSummaryReducer;